import { useState } from "react"

const useTokenListItem = (name) => {
  const [copied, setCopied] = useState(false)
  const varName = `var(--${name})`

  const copyImport = () => {
    if (typeof navigator.clipboard !== "undefined") {
      navigator.clipboard.writeText(varName)
      showCopiedMessage()
      return
    }
    const textArea = document.createElement("textarea")
    textArea.value = varName
    textArea.style.position = "fixed"
    document.body.append(textArea)
    textArea.focus()
    textArea.select()
    try {
      const copySuccess = document.execCommand("copy")
      if (copySuccess) {
        showCopiedMessage()
      }
    } catch (error) {
      const errorMsg = error.message || "Erro inesperado"
      console.log("Erro ao copiar:", errorMsg)
    } finally {
      document.body.removeChild(textArea)
    }
  }

  const showCopiedMessage = () => {
    if (copied) return
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }

  return {
    copyImport,
    elementHide: copied ? "token-item__imported--show" : "",
  }
}

export default useTokenListItem
